import { apiClient } from "./ApiClient";
import { API_URLS } from "../constants";

export const NurseDataService = {
  getNurseData: async () => {
    try {
      const { data } = await apiClient.get(API_URLS.USER.NURSEDATA);
      return data;
    } catch (error) {
      throw error;
    }
  },

  addNurseData: async (nurseDataItem) => {
    try {
      const { data } = await apiClient.post(API_URLS.USER.NURSEDATA, nurseDataItem);
      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteNurseData: async (itemID) => {
    try {
      const { data } = await apiClient.delete(`${API_URLS.USER.NURSEDATA}${itemID}/`);
      return data;
    } catch (error) {
      throw error;
    }
  },

  updateNurseData: async (itemID, nurseDataItem) => {
    try {
      const { data } = await apiClient.put(`${API_URLS.USER.NURSEDATA}${itemID}/`, nurseDataItem);
      return data;
    } catch (error) {
      throw error;
    }
  },
};
